import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const getHostname = () => {
  switch (publicRuntimeConfig.appEnv) {
    case 'test':
      return 'https://test.bnnvara.nl';
    case 'acc':
      return 'https://acc.bnnvara.nl';
    case 'prod':
      return 'https://www.bnnvara.nl';
    default:
      return 'http://localhost:3000';
  }
};
